import { getApi } from "../utils/api";
import { API_GET_PROJECT_MEMBERS_BY_PROJECT_ID } from "../config/Endpoints";
import Cookies from "js-cookie";

export const fetchTeamMembersListByProjectIdService = async (
  set,
  projectId
) => {
  set({ loading: true });
  try {
    const accessToken = Cookies.get("accessToken");
    const res = await getApi(
      `${API_GET_PROJECT_MEMBERS_BY_PROJECT_ID}/${projectId}`,
      accessToken
    );

    set({
      teamMembersList: res?.data?.data || [],
      loading: false,
    });
  } catch (error) {
    console.error("Failed to fetch team members:", error);
    set({ teamMembersList: [], loading: false });
  }
};
